import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ApiService } from '../../services/api.service';
//import { ICompanyMeta } from '../companies/companies-page';
import { forkJoin } from 'rxjs';

export const detallEmpresaResolver: ResolveFn<{
    assessments: {
    language_id: string;
    assessments: {
        assessment_id: number;
        assessment_description: string;
        start_date: number;
        status_id: number;
        user_id_technician: string;
        workplace_id: number;
        workplace_name: string;
    }[];
    },
    languages: {[k:string]:string}
}> = (route, state) => {
  const api = inject(ApiService);
  // Nota: és obligatori que hi hagi "state"
  const company = inject(Router).currentNavigation()?.extras.state;
  return forkJoin({
    assessments: api.builderCompanyDetail(company!['company_id']),
    languages: api.languages()
  });
};
